/**
 * Make a periodic call to the REST API to check whether a
 * valid login session is present.
 * This information will be stored in a client side cookie to
 * show/hide UI elements
 * Use this approach only if the backend logic from KernelListener and SecuritySubscriber fails
 */


import Axios from 'axios';
import Cookies from 'js-cookie';
import HttpUtil from './http';
import securityUtil from './security';
import store from '@/core/services/store';
import {
  SET_ANONYMOUS_VISIT
} from '@/core/services/store/profile.module';
import ApiService from '@/core/services/api.service';

export default {
  store: store,
  data: {
    polling: null,
    frequencyMilliseconds: 30000,
  },
  created() {
    this.initPolling();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  methods: {
    initPolling() {
      const self = this;
      // further polling
      this.polling = setInterval(() => {
        self.pollData();
      }, self.frequencyMilliseconds);
    },
    pollData(force) {
      const def = $.Deferred();
      // check for authenticated session only if the cookie is already present
      // which means that the user has actually logged in himself
      if (force === true || securityUtil.isAuthenticatedSession()) {
        const url = JsRouting.generate(ApiService.apiRoute('webapi_session_check_user_session'), {
          fully: 0,
        });
        const isSessionCheckRequest = url.indexOf('/webapi/session/check-user-session/') !== -1;
        Axios.get(url).then((response) => {
          if (response.data && response.data.authenticated === false) {
            this.$store.commit(SET_ANONYMOUS_VISIT, true);
            Cookies.remove('APP_SESSION');
            def.resolve();
            return;
          }
          this.$store.commit(SET_ANONYMOUS_VISIT, false);
          def.resolve();
        }).catch((error) => {
          HttpUtil.axiosErroDefaultHandler(error).done((errorString) => {
            const status = error.response ? error.response.status : null;
            this.$store.commit(SET_ANONYMOUS_VISIT, true);
            if (status === 401 || status === 403 || (status === 404 && isSessionCheckRequest)) {
              // no active user session, delete the cookie
              Cookies.remove('APP_SESSION');
            }
            if (status === 404 && isSessionCheckRequest) {
              def.resolve();
              return;
            }

            def.reject();
          });
        }).then(() => {
          // 2nd then after catch is always executed - catch MUST be present for this to work
        });
      } else {
        this.$store.commit(SET_ANONYMOUS_VISIT, true);
        def.resolve();
      }
      return def;
    },
  },
};
